import { IntlProvider } from 'react-intl';
import { translations } from '../utils/i18n';

interface IntlTranslationsProviderProps {
  locale?: string;
  children: React.ReactNode;
}

const IntlTranslationsProvider = ({ locale = 'en', children }: IntlTranslationsProviderProps) => (
  <IntlProvider locale={locale} messages={translations[locale]}>
    {children}
  </IntlProvider>
);

export default IntlTranslationsProvider;
